import React from "react";
import styles from "./App.module.css";
import { v4 as uuidv4 } from "uuid";
import {
  HomePage,
  Item,
  DetailsPage,
  NotFound,
  ConnactUs,
  Search,
} from "./pages";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    const data = window.sessionStorage.getItem("currentSessionId");
    if (data === null || data === undefined || data === "") {
      window.sessionStorage.setItem("currentSessionId", uuidv4());
    }
  }, []);

  return (
    <div className={styles.App}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/item/:id" element={<Item />} />
          <Route path="/details/:id" element={<DetailsPage />} />
          <Route path="/connactus" element={<ConnactUs />} />
          <Route path="/search/:search" element={<Search />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
